import "jquery";
import "../scss/style.scss";
import "./index.js"
